import React, { FC } from 'react';
import '../scss/Footer.scss';
export const Footer: FC = () => {

    return (<footer className="d-flex flex-wrap justify-content-end align-items-center py-3 footer border-top">
    <sup>©</sup> {new Date().getFullYear()} Borderless Software &nbsp;
  </footer>)
};